if (!customElements.get('rd-collection-load-more')) {
  customElements.define(
    'rd-collection-load-more',
    class RoomdenCollectionLoadMore extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-load-more-url]');
        this.progress = this.querySelector('.rd-collection-v1__progress span');
        this.updateProgress();
        this.button?.addEventListener('click', () => this.load());
      }

      updateProgress() {
        const total = Number(this.dataset.total || 0);
        const shown = Number(this.dataset.shown || 0);
        const progress = total > 0 ? Math.min(100, (shown / total) * 100) : 100;
        this.style.setProperty('--rd-collection-progress', `${progress}%`);
      }

      async load() {
        if (!this.button || this.button.disabled) return;
        this.button.disabled = true;
        this.button.setAttribute('aria-busy', 'true');

        try {
          const url = new URL(this.button.dataset.loadMoreUrl, window.location.origin);
          url.searchParams.set('section_id', this.closest('[data-id]')?.dataset.id || this.closest('collection-component')?.querySelector('#product-grid')?.dataset.id || '');
          const response = await fetch(url);
          if (!response.ok) throw new Error(`Collection page request failed: ${response.status}`);
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const nextGrid = html.querySelector('#product-grid');
          const currentGrid = document.querySelector('#product-grid');
          if (!nextGrid || !currentGrid) throw new Error('Collection grid was not found');

          const hasEditorial = Boolean(currentGrid.querySelector('.rd-collection-v1__editorial'));
          Array.from(nextGrid.children).forEach((item) => {
            if (hasEditorial && item.matches('.rd-collection-v1__editorial')) return;
            currentGrid.append(item);
          });
          this.dataset.shown = String(currentGrid.querySelectorAll('.rd-collection-v1__item').length);
          this.updateProgress();

          const nextButton = html.querySelector('[data-load-more-url]');
          if (nextButton?.dataset.loadMoreUrl) {
            this.button.dataset.loadMoreUrl = nextButton.dataset.loadMoreUrl;
            this.button.disabled = false;
            this.button.removeAttribute('aria-busy');
          } else {
            this.button.remove();
            this.button = null;
          }
        } catch (error) {
          console.error(error);
          this.button.disabled = false;
          this.button.removeAttribute('aria-busy');
        }
      }
    }
  );
}

document.addEventListener('click', (event) => {
  const sortOption = event.target.closest('[data-rd-sort-value]');
  if (sortOption) {
    const sortMenu = sortOption.closest('[data-rd-sort-menu]');
    const sortControl = sortOption.closest('.rd-sort-control');
    const sortSelect = sortControl?.querySelector('select[name="sort_by"]');
    const currentLabel = sortMenu?.querySelector('[data-rd-sort-current]');

    if (sortSelect && sortMenu) {
      sortSelect.value = sortOption.dataset.rdSortValue;
      if (currentLabel) currentLabel.textContent = sortOption.querySelector('span')?.textContent.trim() || sortOption.textContent.trim();
      sortMenu.querySelectorAll('[data-rd-sort-value]').forEach((option) => {
        option.setAttribute('aria-selected', String(option === sortOption));
      });
      sortMenu.open = false;
      sortSelect.dispatchEvent(new Event('input', { bubbles: true }));
      sortSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }
    return;
  }

  document.querySelectorAll('[data-rd-sort-menu][open]').forEach((sortMenu) => {
    if (!sortMenu.contains(event.target)) sortMenu.open = false;
  });

  const mobileFacetsApply = event.target.closest('.rd-collection-v1 .mobile-facets__footer .button--primary');
  if (mobileFacetsApply) {
    const drawer = mobileFacetsApply.closest('menu-drawer');
    const trigger = drawer?.rdCollectionTrigger;

    window.setTimeout(() => {
      if (!drawer?.querySelector(':scope > details')?.open) trigger?.focus();
    }, 450);
    return;
  }

  const mobileFacetsBackdrop = event.target.closest('.rd-collection-v1 .mobile-facets');
  if (mobileFacetsBackdrop && !event.target.closest('.mobile-facets__inner')) {
    const drawer = mobileFacetsBackdrop.closest('menu-drawer');
    const drawerDetails = drawer?.querySelector(':scope > details');
    const drawerSummary = drawerDetails?.querySelector(':scope > summary');

    if (drawer && drawerDetails?.open && drawerSummary) {
      drawerSummary.setAttribute('aria-expanded', 'false');
      drawer.closeMenuDrawer(event, drawer.rdCollectionTrigger || drawerSummary);
      drawerDetails.removeAttribute('open');
    }
    return;
  }

  const trigger = event.target.closest('[data-mobile-filter-open], [data-mobile-sort-open]');
  if (!trigger) return;
  const drawer = document.querySelector('.rd-collection-v1 menu-drawer');
  const drawerDetails = drawer?.querySelector(':scope > details');
  const drawerSummary = drawerDetails?.querySelector(':scope > summary');

  if (!drawer || !drawerDetails || !drawerSummary) return;

  drawer.rdCollectionTrigger = trigger;

  if (!drawerDetails.open) {
    drawerDetails.open = true;
    drawer.openMenuDrawer(drawerSummary);
  }

  requestAnimationFrame(() => {
    const filterLabel = trigger.dataset.mobileFilterLabel?.trim();
    if (filterLabel) {
      const matchingSummary = Array.from(document.querySelectorAll('.rd-collection-v1 .mobile-facets__details > summary'))
        .find((summary) => summary.textContent.trim() === filterLabel);
      const matchingDetails = matchingSummary?.closest('details');
      if (matchingSummary && !matchingDetails?.open) matchingSummary.click();
      matchingSummary?.focus();
      return;
    }

    const focusTarget = trigger.matches('[data-mobile-sort-open]')
      ? document.querySelector('#SortBy-mobile')
      : document.querySelector('.rd-collection-v1 .mobile-facets__close');
    focusTarget?.focus();
  });
});

document.addEventListener('change', (event) => {
  const filterOption = event.target.closest(
    '#FacetFiltersForm .facets__display input[type="checkbox"], #FacetFiltersForm .facets__display input[type="radio"]'
  );
  if (!filterOption) return;

  const disclosure = filterOption.closest('details.facets__disclosure');
  if (!disclosure) return;

  disclosure.open = false;
  const summary = disclosure.querySelector(':scope > summary');
  if (summary?.hasAttribute('aria-expanded')) summary.setAttribute('aria-expanded', 'false');
});
